/* eslint-disable semi */
import { application } from './application';

/**
 * router定義補正
 */
const correctRoutes = function (...args) {
  args.forEach(row => {
    // ソート用プロパティ追加
    row.sortPath = row.path.replace(/\/:[^\\/]*/g, '/*');

    // メタ情報補正
    row.meta = row.meta || {};

    // 親階層の定義を自動設定
    let parent = row.name.split('/');
    parent.pop();
    parent = parent.join('/');
    if (parent !== '') {
      if (row.meta.parent !== parent) {
        row.meta.parent = parent;
      }
    }
  });

  // パスでソート
  args.sort(function (arg1, arg2) {
    return (arg1.sortPath > arg2.sortPath) ? -1 : (arg1.sortPath < arg2.sortPath) ? 1 : 0;
  });

  // ソート用のプロパティ削除
  args.forEach(row => {
    delete row.sortPath;
  });

  return args;
}

export const routes = [
  {
    path: '/',
    component: () => import('@/app/structure/AppContainer'),
    children: [
      {
        name: 'TOP',
        path: '/',
        component: () => import('@/app/pages/PageTop'),
        meta: { title: 'Top', isPublic: true, layout: 'default' }
      },
      {
        name: 'LOGIN',
        path: '/login',
        component: () => import('@/app/pages/login/PageLogin'),
        meta: { title: 'WEB受付', isPublic: true, layout: 'default' }
      },
      {
        name: 'LOGOUT',
        path: '/logout',
        component: () => import('@/app/pages/PageLogout'),
        meta: { title: 'ログアウト', isPublic: true, layout: 'default' }
      },
      {
        name: 'ENTRY',
        path: '/entry',
        component: () => import('@/app/pages/entry/PageEntry'),
        meta: { title: 'WEB受付', isPublic: false, layout: 'default' }
      },

      // ----------------------------------------------------------------------
      // アプリケーションの定義を差込
      // ----------------------------------------------------------------------
      ...correctRoutes(
        ...application
      ),

      // ----------------------------------------------------------------------
      // エラー
      // ----------------------------------------------------------------------
      {
        name: 'U999999',
        path: '/error',
        component: () => import('@/app/pages/PageError'),
        meta: { title: 'エラー', isPublic: true, layout: 'top' },
        props: true
      },
      {
        name: 'U999999-404',
        path: '*',
        component: () => import('@/app/pages/Page404'),
        meta: { isPublic: true, layout: 'top', title: 'エラー' }
      }

    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js